export default "__VITE_ASSET__ncnzMFSv__"